import { Observable, Subject } from 'rxjs'
import { Component, Injector } from '@angular/core'
import { Store } from '@ngrx/store'

import { ViewModel } from '../../../../view-model'
import { BasePage } from '../../../../base-page'
import { UIEvent } from '../../../../services/event.service'
import { apiCalls } from './plncmm10000sc00-00.api-call.page'

/**
 * Dashboardページコンポーネント
 * @author nabla2.metamodel.generator
 */

@Component({
  selector: 'page-plncmm10000sc00-00',
  templateUrl: 'plncmm10000sc00-00.page.html'
})
export class Plncmm10000sc0000Page extends BasePage {

  /** 画面名 */
  pageName:string = 'plncmm10000sc00-00'

  /** 機能名 */
  featureName:string = 'cmnfnc-base'

  /**
   * コンストラクタ
   * @param injector Injector
   * @param store Reduxストア
   */
  constructor(
    public injector: Injector,
    public store: Store<{viewModel:ViewModel}>
  ) {
    super(injector, store)
  }

  /**
   * メンバ変数の初期化とリアクティブストリームの監視を開始する。
   */
  ionViewWillEnter() {
    this.unload$ = new Subject<void>()
    this.store.select('viewModel')
              .takeUntil(this.unload$)
              .subscribe(v => this.viewModel = v)
    this.subscribe([
      `画面が表示されたとき 【selectedDashboardMenu】の内容が直近のセッションストレージ上のスナップショットと異なれば`,
      `画面が表示されたとき`,
      `画面が表示されたとき ログイン状態であれば`,
      `【Authorization User Blng Business Unit Info】が正常応答したとき`,
      `【DashboardMenuForm.DashboardMenuNotification】を押したとき`,
      `【DashboardMenuForm.DashboardMenuNotificationUpload】を押したとき`,
      `【DashboardMenuForm.DashboardMenuOfficialPlan】を押したとき`,
      `【DashboardMenuForm.DashboardMenuSalesInventoryPlan】を押したとき`,
      `【DashboardMenuForm.DashboardMenuProduction】を押したとき`,
      `【DashboardMenuForm.DashboardMenuOrder】を押したとき`,
      `【DashboardMenuForm.DashboardMenuRawMaterialPlan】を押したとき`,
      `【DashboardMenuForm.DashboardMenuInventoryControl】を押したとき`,
      `【DashboardMenuForm.DashboardMenuCommonMaster】を押したとき`,
      `【DashboardMenuForm.DashboardMenuMaterialManagement】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimAllocation】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimLogistics】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimItemPrice】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimInventoryAccuracy】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimMasterDownload】を押したとき`,
      `【DashboardMenuForm.DashboardMenuAimAdmin】を押したとき`,
      `【selectedDashboardMenu】が変わったとき`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"notification_upload"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"official_plan"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"sales_inventory_plan"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"production"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"order"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"raw_material_plan"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"inventory_control"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"common_master"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"material_management"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_allocation"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_logistics"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_item_price"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_inventory_accuracy"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_master_download"】であれば`,
      `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_admin"】であれば`,
      `【DashboardContentsNotificationUploadForm.DashboardContentsNotificationUpload】を押したとき`,
      `【Notification Upload API】が正常応答したとき`,
      `APIがユーザエラーで応答したとき`,
      `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば`,
      `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば、かつ【selectedDashboardUrl】が【""】でなければ`,
      `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】でなければ`,
      `【dashboardRedirectUrl】が変わったとき 【showConfirmDialog】が【"true"】であれば`,
      `【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空であれば`,
      `【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空でなければ`,
      `確認ダイアログ【"dashboard_confirm_ok"】ボタンを押したとき`,
      `確認ダイアログ【"dashboard_confirm_cancel"】ボタンを押したとき`,
      `【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0】が【true】でなければ`,
      `【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0 && dashboardRedirectUrl !== ""】が【true】であれば`,
      `【Online Block Status】が正常応答したとき`,
      `【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"Y"】であれば`,
      `【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"N"】であれば`,
      `【DashboardMenuForm.userRolePulldown】を変更したとき 【userRoleSelected】が【""】でなければ`,
      `【DashboardMenuForm.businessUnitPulldown】を変更したとき 【businessUnitSelected】が【""】でなければ`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalDirectionByDept】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalOfficialPlan】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemSampleLink】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanPreviousYearSumMappingLYComparison】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemRelocation】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryMaster】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryRegistration】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanSeasonalCoreCategorySummaryGlobalComparison】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByCoreCategory】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomLeft.officialPlanLocalOfficialPlanSalesAmountGlobalComparisonDeptSubCategory1】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByPjItem】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanLocalOfficialPlan】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPreviousYearSumMappingCarryover】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPriceCOGSSimulation】を押したとき`,
      `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPricelineRegistration】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanSalesAmountByCoreCategory】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanVerificationReportByCoreCategoryByPlanningSum】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanOfficialPlanRawdataExport】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlan】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.RegionalNumOfStoreMaster】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.RegionalSeasonDeptBasedBusinessPlanInboundProcess】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.RegionalPreviousSeasonResultsRegistration】を押したとき`,
      `【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlanOfficialPlanRawdataExport】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySalesSum】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanPromotionMasterSetting】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanEndOfSeasonInventory】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanWeeklyPrintableForm】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckRepSkuSetting】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckSeasonEndTotalInventoryList】を押したとき`,
      `【DashboardContentsSalesInventoryPlanForm2.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySku】を押したとき`,
      `【DashboardContentsProductionForm1.ProductionPlan】を押したとき`,
      `【DashboardContentsProductionForm1.ProductionCapacityGraph】を押したとき`,
      `【DashboardContentsProductionForm1.ProductionFactoryBasedPlan】を押したとき`,
      `【DashboardContentsProductionForm1.ProductionPlanSimulation】を押したとき`,
      `【DashboardContentsProductionForm1.productionPlanPublishmentForFactory】を押したとき`,
      `【DashboardContentsProductionForm1.productionPlanFactoryForCapacityGraph】を押したとき`,
      `【DashboardContentsProductionForm1.productionPlanFactoryCapacityPlan】を押したとき`,
      `【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkSewingFabric】を押したとき`,
      `【DashboardContentsProductionForm1.productionPlanStopGoFileUpload】を押したとき`,
      `【DashboardContentsProductionForm1.productionPlanDLSheet】を押したとき`,
      `【DashboardContentsProductionForm1.productionCapacityGraphOutput】を押したとき`,
      `【DashboardContentsProductionForm1.representativeManagementFactorySetting】を押したとき`,
      `【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkFabric】を押したとき`,
      `【DashboardContentsProductionForm2.ProductionProcessBasedLeadtime】を押したとき`,
      `【DashboardContentsProductionForm2.ProductionOrderConditionRegistration】を押したとき`,
      `【DashboardContentsProductionForm4.productionPlanMdView】を押したとき`,
      `【DashboardContentsProductionForm4.productionPlanPrdFctView】を押したとき`,
      `【DashboardContentsProductionForm4.productionPlanUnexRawdata】を押したとき`,
      `【DashboardContentsProductionForm5.ProductionPlanRawdataExport】を押したとき`,
      `【DashboardContentsProductionForm5.DetectionOfOrderProgress】を押したとき`,
      `【DashboardContentsOrderForm1.ProductionGlobalColorSizeOrderSetting】を押したとき`,
      `【DashboardContentsOrderForm1.ProductionReferenceItemMapping】を押したとき`,
      `【DashboardContentsOrderForm2.ProductionLocalColorSizeOrderSetting】を押したとき`,
      `【DashboardContentsOrderForm2.ProductionOrderPlanList】を押したとき`,
      `【DashboardContentsOrderForm2.ProductionBDSheet】を押したとき`,
      `【DashboardContentsOrderForm3.ProductionOrderExecutionList】を押したとき`,
      `【DashboardContentsOrderForm3.ProductionOrderApprovalList】を押したとき`,
      `【DashboardContentsOrderForm3.ProductionOrderApprovalListForMobile】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionCostSequenceNoRegistration】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionItemAttributeList】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionPackingInstruction】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionWHDistributionRatioRegistration】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionThresholdRegistration】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionTransferItemRegistration】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionDefaultPackingQuantitySetting】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionDoChange】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionDoAllocation】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionExceptionalItemRegistration】を押したとき`,
      `【DashboardContentsOrderForm4.ProductionNAssortRatioRegistration】を押したとき`,
      `【DashboardContentsInventoryControlForm.InventoryControlStoreParameterSetting】を押したとき`,
      `【DashboardContentsInventoryControlForm.InventoryControlSalesSumParameterSetting】を押したとき`,
      `【DashboardContentsCommonMasterForm.CommonMasterSeasonRateMaster】を押したとき`,
      `【DashboardContentsCommonMasterForm.CommonMasterNumberOfStoreMaster】を押したとき`,
      `【DashboardContentsMatFormTopLeft.MaterialDiversionRegistration】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.OrderExecutionList】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.OrderApprovalList】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.OrderApprovalListForMobile】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.BoForEarlyMaterialOrder】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.BoForReservedMaterialOrder】を押したとき`,
      `【DashboardContentsMatFormBottomLeft.BdForReservedMaterialOrder】を押したとき`,
      `【DashboardContentsMatFormBottomRight.RawdataExportForMaterialRemainsConfirmation】を押したとき`,
      `【DashboardContentsMatFormBottomRight.MaterialPlanAndOrder】を押したとき`,
      `【DashboardContentsMatFormTopRight.AutomaticAssignmentExclusionFRMaterialRegistration】を押したとき`,
      `【DashboardContentsMatFormTopRight.OrderProcessPatternMasterRegistration】を押したとき`,
      `【DashboardContentsMatFormTopRight.MasterForMaterialPlanAndOrder】を押したとき`,
      `【DashboardContentsAimInventoryCockpitForm.AimControlCockpit】を押したとき`,
      `【DashboardContentsAimReportForm.AimReferenceForTransfer】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfDemandForecast】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimWeeklyStockPlanbyLineupType】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStyle】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfStoreAlocGthrUpperLowerLimited】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStore】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatio】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimDownloadOfFaceRatioFile】を押したとき`,
      `【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfDeliveryRatioByDay】を押したとき`,
      `【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfItemInformation】を押したとき`,
      `【DashboardContentsAimSPSSettingForm2.AimInformationRegistration】を押したとき`,
      `【DashboardContentsAimSPSSettingForm2.AimSettingOfLineTypeByStore】を押したとき`,
      `【DashboardContentsAimSPSSettingForm2.AimWeeklyStandartStockUploadBySku】を押したとき`,
      `【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatioNew】を押したとき`,
      `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStyle】を押したとき`,
      `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingForEcByStyle】を押したとき`,
      `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStore】を押したとき`,
      `【DashboardContentsAimStoreOrderForm1.AimReplenishmentDateSetting】を押したとき`,
      `【DashboardContentsAimStoreOrderForm1.AimProhibitedDeliveryDateSettingByStoreAndGdept】を押したとき`,
      `【DashboardContentsAimStoreOrderForm2.AimReplenishmentTargetSettingBySku】を押したとき`,
      `【DashboardContentsAimStoreOrderForm2.AimSettingOfLayawayStockStatusShift】を押したとき`,
      `【DashboardContentsAimStoreOrderForm2.AimDownloadOfLayawayStockStatusFile】を押したとき`,
      `【DashboardContentsAimStoreOrderForm2.AimStoreAllocationPrioritySetting】を押したとき`,
      `【DashboardContentsAimStoreOrderForm2.AimExcelDownloadOfReplenishmentControl】を押したとき`,
      `【DashboardContentsAimSCOrderForm1.AimScOrderHome】を押したとき`,
      `【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByItem】を押したとき`,
      `【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByAssortSku】を押したとき`,
      `【DashboardContentsAimSCOrderForm2.AimUrgentRequestForShipment】を押したとき`,
      `【DashboardContentsAimSCOrderForm2.AimStoreGroupMaintenance】を押したとき`,
      `【DashboardContentsAimSCOrderForm2.AimSettingOfTemporaryFaceRatio】を押したとき`,
      `【DashboardContentsAimTransferConsolidationForm.AimSearchForTransferOfAllItemsAndReturnToVender】を押したとき`,
      `【DashboardContentsAimTransferConsolidationForm.AimAreaManagerStoreToStoreDeliveryOrder】を押したとき`,
      `【DashboardContentsAimTransferConsolidationForm.AimSettingOfTransferToConcentrateStock】を押したとき`,
      `【DashboardContentsAimStoreSettingForm.AimLogisticsTerritoryMaintenance】を押したとき`,
      `【DashboardContentsAimStoreSettingForm.AimSettingOfPriorityAllocationByStore】を押したとき`,
      `【DashboardContentsAimStoreSettingForm.AimLogisticsMasterMaintenance】を押したとき`,
      `【DashboardContentsAimItemSettingForm.AimWarehouseByItemCollectiveSetting】を押したとき`,
      `【DashboardContentsAimItemSettingForm.AimSettingOfWarehouseByItem】を押したとき`,
      `【DashboardContentsAimTransferForm.AimTransferSearchWindow】を押したとき`,
      `【DashboardContentsAimTransferForm.AimTransferInstructionWarehouseExcelUpload】を押したとき`,
      `【DashboardContentsAimMinimumDeliveryQuantityForm.AimSettingOfMinimumQtyByGdeptClass】を押したとき`,
      `【DashboardContentsAimWhWhMasterForm.AimWh2WhOrderRegionMaintenance】を押したとき`,
      `【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLowerLimitOfShippable】を押したとき`,
      `【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLeadTime】を押したとき`,
      `【DashboardContentsAimWhWhMasterForm.AimWh2WhSettingOfCartonVolume】を押したとき`,
      `【DashboardContentsAimWhWhOrderForm.AimWh2WhReplenishmentApprovalByGdept】を押したとき`,
      `【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingItem】を押したとき`,
      `【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingCopySetting】を押したとき`,
      `【DashboardContentsAimSumMaintenanceForm.AimSumCodeSetting】を押したとき`,
      `【DashboardContentsAimSumMaintenanceForm.AimRepSkuSetting】を押したとき`,
      `【DashboardContentsAimSumMaintenanceForm.AimAllocationPrioritySettingBySku】を押したとき`,
      `【DashboardContentsAimSumMaintenanceForm.AimUserAttributeMaintenance】を押したとき`,
      `【DashboardContentsAimAssortmaintenanceForm.AimAssortmentMaintenance】を押したとき`,
      `【DashboardContentsAimPriceChangeForm.AimPriceChangeSearch】を押したとき`,
      `【DashboardContentsAimPriceChangeForm.AimPriceChangeExcelUpload】を押したとき`,
      `【DashboardContentsAimPriceChangeForm.AimPricelineMaintenance】を押したとき`,
      `【DashboardContentsAimPromotionForm.AimEventList】を押したとき`,
      `【DashboardContentsAimPromotionForm.AimPromotionExcelUpload】を押したとき`,
      `【DashboardContentsAimPromotionForm.AimPromotionExcelUploadItemAndPrice】を押したとき`,
      `【DashboardContentsAimInventoryMaintenanceForm.AimSearchForDeliveryAndShipmentHistory】を押したとき`,
      `【DashboardContentsAimInventoryMaintenanceForm.AimConfirmationOfExcelUploadingOfShipment】を押したとき`,
      `【DashboardContentsAimInventoryMaintenanceForm.AimInventoryAdjustmentStockStatusShift】を押したとき`,
      `【DashboardContentsAimInventoryMaintenanceForm.AimBookTransfer】を押したとき`,
      `【DashboardContentsAimStockTakingForm.AimStockTakeRequestMaintenance】を押したとき`,
      `【DashboardContentsAimStockTakingForm.AimConfirmationOfExcelUploadingOfStocktakingAdjustment】を押したとき`,
      `【DashboardContentsAimStockTakingForm.AimExcelOutputOfStocktakingAdjustment】を押したとき`,
      `【DashboardContentsAimMasterForm.AimMasterDownload】を押したとき`,
      `【DashboardContentsAimStoreMasterForm.AimStoreMaintenance】を押したとき`,
      `【DashboardContentsAimStoreMasterForm.AimAreaMaintenance】を押したとき`,
      `【DashboardContentsAimStoreMasterForm.AimBlockMaintenance】を押したとき`,
      `【DashboardContentsAimLogisticsMasterForm.AimWarehouseMaintenance】を押したとき`,
      `【DashboardContentsAimLogisticsMasterForm.AimOrderRegionMaintenance】を押したとき`,
      `【DashboardContentsAimLogisticsMasterForm.AimLogisticsCompanyMaintenance】を押したとき`,
      `【DashboardContentsAimLogisticsMasterForm.AimReferenceNumberMasterMaintenance】を押したとき`,
      `【DashboardContentsAimPOSMasterForm.AimTenderType】を押したとき`,
      `【DashboardContentsAimPOSMasterForm.AimMaintenanceOfCreditCompanyInfo】を押したとき`,
      `【DashboardContentsAimPOSMasterForm.AimCodeMaintenanceOfNonItemSales】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimPosDataSearch】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimStoreSummaryDataDetail】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimReferenceOfBalanceBetweenSalesAndPos】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimReferenceOfSalesDataCollection】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimSearchForDailyConditionOfStores】を押したとき`,
      `【DashboardContentsAimPOSDataForm.AimSearchForChangeHistoryOfPosData】を押したとき`,
      `【DashboardContentsAimSystemControlForm.AimPosDataFileImport】を押したとき`,
      `【DashboardContentsAimSystemControlForm.AimEndOfMonthProcessing】を押したとき`,
      `【DashboardContentsAimSystemControlForm.AimDelayedOnlineBatchManagement】を押したとき`,
      `【DashboardContentsAimSystemControlForm.AimDataDeliveryToStoresOnSystemErrors】を押したとき`,
      `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimGeocodeHierarchyMaintenance】を押したとき`,
      `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxHierarchy】を押したとき`,
      `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxRateView】を押したとき`,
      `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimVATItemMaintenance】を押したとき`,
    ])
  }

  /**
   * 指定された表示モデルパスにバインドされた項目に表示するエラーメッセージを取得する。
   * @param modelPath 表示モデルパス
   */
  errorMessages(modelPath:string):{modelPath:string, message:string}[] {
    if (!this.viewModel) return []
    return this.viewModel.errorMessages.filter(e => e.modelPath === modelPath)

  }

  /**
   * この画面のイベント定義に従って対応するイベントストリームの監視を開始する。
   * @param eventNames この画面のイベント論理名
   */
  subscribe(eventNames:string[]) {
    eventNames.forEach(eventName => {
      this.event(eventName)
      .takeUntil(this.unload$)
      .subscribe(e => this.store.dispatch({
        type  :`${this.featureName}/${this.pageName}/${eventName}`,
        event :e,
        desc  :eventName,
      }))
    })
    let prevPage = this.navCtrl.getPrevious()
    if (prevPage && (prevPage.id === `${this.featureName}-${this.pageName}`)) {
      prevPage = this.navCtrl.last()
    }
    this.eventHub.next({
      type   :'page_initialized',
      id     :`${this.featureName}/${this.pageName}`,
      source : {
        page: this.pageName, feature: this.featureName, prevPage: (prevPage ? prevPage.id : "")
      }
    })
  }

  /**
   * ページ内イベント定義
   * @param type ページ内イベント論理名
   */
  event(type:string):Observable<UIEvent<any>> {
    switch (type) {
      case `画面が表示されたとき 【selectedDashboardMenu】の内容が直近のセッションストレージ上のスナップショットと異なれば` :
        return this.eventHub.whenPageInitialized()
       .filter(this.eventHub.ifStateDiffersFromItsLatestSessionStorageSnapshot(
          'cmnfnc_base.selected_dashboard_menu'
       ))
      case `画面が表示されたとき` :
        return this.eventHub.whenPageInitialized()
      case `画面が表示されたとき ログイン状態であれば` :
        return this.eventHub.whenPageInitialized()
       .filter(this.eventHub.ifStateHasAlreadyLoggedIn())
      case `【Authorization User Blng Business Unit Info】が正常応答したとき` :
        return this.eventHub.whenGivenApiRespondedSuccessfully(
          apiCalls['Authorization User Blng Business Unit Info']
        )
      case `【DashboardMenuForm.DashboardMenuNotification】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.notification'
        )
      case `【DashboardMenuForm.DashboardMenuNotificationUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_notification_upload'
        )
      case `【DashboardMenuForm.DashboardMenuOfficialPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_official_plan'
        )
      case `【DashboardMenuForm.DashboardMenuSalesInventoryPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_sales_inventory_plan'
        )
      case `【DashboardMenuForm.DashboardMenuProduction】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_production'
        )
      case `【DashboardMenuForm.DashboardMenuOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_order'
        )
      case `【DashboardMenuForm.DashboardMenuRawMaterialPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_raw_material_plan'
        )
      case `【DashboardMenuForm.DashboardMenuInventoryControl】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_inventory_control'
        )
      case `【DashboardMenuForm.DashboardMenuCommonMaster】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_common_master'
        )
      case `【DashboardMenuForm.DashboardMenuMaterialManagement】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_material_management'
        )
      case `【DashboardMenuForm.DashboardMenuAimAllocation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_allocation'
        )
      case `【DashboardMenuForm.DashboardMenuAimLogistics】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_logistics'
        )
      case `【DashboardMenuForm.DashboardMenuAimItemPrice】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_item_price'
        )
      case `【DashboardMenuForm.DashboardMenuAimInventoryAccuracy】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_inventory_accuracy'
        )
      case `【DashboardMenuForm.DashboardMenuAimMasterDownload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_master_download'
        )
      case `【DashboardMenuForm.DashboardMenuAimAdmin】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.dashboard_menu_aim_admin'
        )
      case `【selectedDashboardMenu】が変わったとき` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"notification_upload"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('notification_upload')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"official_plan"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('official_plan')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"sales_inventory_plan"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('sales_inventory_plan')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"production"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('production')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"order"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('order')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"raw_material_plan"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('raw_material_plan')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"inventory_control"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('inventory_control')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"common_master"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('common_master')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"material_management"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('material_management')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_allocation"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_allocation')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_logistics"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_logistics')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_item_price"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_item_price')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_inventory_accuracy"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_inventory_accuracy')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_master_download"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_master_download')
       ))
      case `【selectedDashboardMenu】が変わったとき 【selectedDashboardMenu】が【"aim_admin"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_menu)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.selected_dashboard_menu',
          (viewModel:ViewModel) => ('aim_admin')
       ))
      case `【DashboardContentsNotificationUploadForm.DashboardContentsNotificationUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_notification_upload_form.dashboard_contents_notification_upload'
        )
      case `【Notification Upload API】が正常応答したとき` :
        return this.eventHub.whenGivenApiRespondedSuccessfully(
          apiCalls['Notification Upload API']
        )
      case `APIがユーザエラーで応答したとき` :
        return this.eventHub.whenApiRespondedUserError()
      case `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_url)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.user_role_selected',
          (viewModel:ViewModel) => ('')
       ))
      case `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】であれば、かつ【selectedDashboardUrl】が【""】でなければ` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_url)
        )
       .filter(this.eventHub.ifOneStateIsSameAndAnotherStateIsNotSameWith(
          'cmnfnc_base.user_role_selected',
          (viewModel:ViewModel) => (''),
          'cmnfnc_base.selected_dashboard_url',
          (viewModel:ViewModel) => ('')
       ))
      case `【selectedDashboardUrl】が変わったとき 【userRoleSelected】が【""】でなければ` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_dashboard_url)
        )
       .filter(this.eventHub.ifStateIsNotSameWith(
          'cmnfnc_base.user_role_selected',
          (viewModel:ViewModel) => ('')
       ))
      case `【dashboardRedirectUrl】が変わったとき 【showConfirmDialog】が【"true"】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url)
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.show_confirm_dialog',
          (viewModel:ViewModel) => ('true')
       ))
      case `【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_ariake_inventory_management_dashboard_url)
        )
       .filter(this.eventHub.ifStateIsBlank(
          'cmnfnc_base.business_unit_selected'
       ))
      case `【selectedAriakeInventoryManagementDashboardUrl】が変わったとき 【businessUnitSelected】が空でなければ` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.selected_ariake_inventory_management_dashboard_url)
        )
       .filter(this.eventHub.ifStateIsNotBlank(
          'cmnfnc_base.business_unit_selected'
       ))
      case `確認ダイアログ【"dashboard_confirm_ok"】ボタンを押したとき` :
        return this.eventHub.whenConfirmDialogButtonPressed(
          (viewModel:ViewModel) => ('dashboard_confirm_ok')
        )
      case `確認ダイアログ【"dashboard_confirm_cancel"】ボタンを押したとき` :
        return this.eventHub.whenConfirmDialogButtonPressed(
          (viewModel:ViewModel) => ('dashboard_confirm_cancel')
        )
      case `【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0】が【true】でなければ` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url)
        )
       .filter(this.eventHub.ifValueIsNotSameWith(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.ariake_inventory_management_dashboard_menu_list.indexOf(viewModel.cmnfnc_base.selected_dashboard_menu)>=0),
          (viewModel:ViewModel) => (true)
       ))
      case `【dashboardRedirectUrl】が変わったとき 値【ariakeInventoryManagementDashboardMenuList.indexOf(selectedDashboardMenu)>= 0 && dashboardRedirectUrl !== ""】が【true】であれば` :
        return this.eventHub.whenStateGetsChanged(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.dashboard_redirect_url)
        )
       .filter(this.eventHub.ifValueIsSameWith(
          (viewModel:ViewModel) => (viewModel.cmnfnc_base.ariake_inventory_management_dashboard_menu_list.indexOf(viewModel.cmnfnc_base.selected_dashboard_menu)>=0&&viewModel.cmnfnc_base.dashboard_redirect_url!== ''),
          (viewModel:ViewModel) => (true)
       ))
      case `【Online Block Status】が正常応答したとき` :
        return this.eventHub.whenGivenApiRespondedSuccessfully(
          apiCalls['Online Block Status']
        )
      case `【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"Y"】であれば` :
        return this.eventHub.whenGivenApiRespondedSuccessfully(
          apiCalls['Online Block Status']
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.online_block_status_flg',
          (viewModel:ViewModel) => ('Y')
       ))
      case `【Online Block Status】が正常応答したとき 【onlineBlockStatusFlg】が【"N"】であれば` :
        return this.eventHub.whenGivenApiRespondedSuccessfully(
          apiCalls['Online Block Status']
        )
       .filter(this.eventHub.ifStateIsSameWith(
          'cmnfnc_base.online_block_status_flg',
          (viewModel:ViewModel) => ('N')
       ))
      case `【DashboardMenuForm.userRolePulldown】を変更したとき 【userRoleSelected】が【""】でなければ` :
        return this.eventHub.whenItemChanged(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.user_role_pulldown'
        )
       .filter(this.eventHub.ifStateIsNotSameWith(
          'cmnfnc_base.user_role_selected',
          (viewModel:ViewModel) => ('')
       ))
      case `【DashboardMenuForm.businessUnitPulldown】を変更したとき 【businessUnitSelected】が【""】でなければ` :
        return this.eventHub.whenItemChanged(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.menu_form.business_unit_pulldown'
        )
       .filter(this.eventHub.ifStateIsNotSameWith(
          'cmnfnc_base.business_unit_selected',
          (viewModel:ViewModel) => ('')
       ))
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalDirectionByDept】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_global_direction_by_dept'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalOfficialPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_global_official_plan'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemSampleLink】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_global_item_sample_link'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanPreviousYearSumMappingLYComparison】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_previous_year_sum_mapping_ly_comparison'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanGlobalItemRelocation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_global_item_relocation'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryMaster】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_seasonal_core_category_master'
        )
      case `【DashboardContentsOfficialPlanFormTopLeft.OfficialPlanSeasonalCoreCategoryRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_left.dashboard_menu_official_plan_seasonal_core_category_registration'
        )
      case `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanSeasonalCoreCategorySummaryGlobalComparison】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_left.dashboard_menu_official_plan_seasonal_core_category_summary_global_comparison'
        )
      case `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByCoreCategory】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_left.dashboard_menu_official_plan_local_official_plan_sales_amount_global_comparison_by_core_category'
        )
      case `【DashboardContentsOfficialPlanFormBottomLeft.officialPlanLocalOfficialPlanSalesAmountGlobalComparisonDeptSubCategory1】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_left.dashboard_menu_official_plan_local_official_plan_sales_amount_global_comparison_dept_sub_category1'
        )
      case `【DashboardContentsOfficialPlanFormBottomLeft.OfficialPlanLocalOfficialPlanSalesAmountGlobalComparisonByPjItem】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_left.dashboard_menu_official_plan_local_official_plan_sales_amount_global_comparison_by_pj_item'
        )
      case `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanLocalOfficialPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_right.dashboard_menu_official_plan_local_official_plan'
        )
      case `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPreviousYearSumMappingCarryover】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_right.dashboard_menu_official_plan_previous_year_sum_mapping_carryover'
        )
      case `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPriceCOGSSimulation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_right.dashboard_menu_official_plan_price_cogss_imulation'
        )
      case `【DashboardContentsOfficialPlanFormTopRight.OfficialPlanPricelineRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_top_right.dashboard_menu_official_plan_priceline_registration'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanSalesAmountByCoreCategory】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.dashboard_menu_official_plan_local_official_plan_sales_amount_by_core_category'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanLocalOfficialPlanVerificationReportByCoreCategoryByPlanningSum】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.dashboard_menu_official_plan_local_official_plan_verification_report_by_core_category_by_planning_sum'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.OfficialPlanOfficialPlanRawdataExport】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.dashboard_menu_official_plan_official_plan_rawdata_export'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.regional_official_plan'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.RegionalNumOfStoreMaster】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.regional_num_of_store_master'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.RegionalSeasonDeptBasedBusinessPlanInboundProcess】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.regional_season_dept_based_business_plan_inbound_process'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.RegionalPreviousSeasonResultsRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.regional_previous_season_results_registration'
        )
      case `【DashboardContentsOfficialPlanFormBottomRight.RegionalOfficialPlanOfficialPlanRawdataExport】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_official_plan_form_bottom_right.regional_official_plan_official_plan_rawdata_export'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySalesSum】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_sales_inventory_planning_by_sales_sum'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanPromotionMasterSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_promotion_master_setting'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanEndOfSeasonInventory】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_end_of_season_inventory'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanWeeklyPrintableForm】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_weekly_printable_form'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckRepSkuSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_check_rep_sku_setting'
        )
      case `【DashboardContentsSalesInventoryPlanForm1.DashboardMenuSalesInventoryPlanCheckSeasonEndTotalInventoryList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_1.dashboard_menu_sales_inventory_plan_check_season_end_total_inventory_list'
        )
      case `【DashboardContentsSalesInventoryPlanForm2.DashboardMenuSalesInventoryPlanSalesInventoryPlanningBySku】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_sales_inventory_plan_form_2.dashboard_menu_sales_inventory_plan_sales_inventory_planning_by_sku'
        )
      case `【DashboardContentsProductionForm1.ProductionPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan'
        )
      case `【DashboardContentsProductionForm1.ProductionCapacityGraph】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_capacity_graph'
        )
      case `【DashboardContentsProductionForm1.ProductionFactoryBasedPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_factory_based_plan'
        )
      case `【DashboardContentsProductionForm1.ProductionPlanSimulation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_simulation'
        )
      case `【DashboardContentsProductionForm1.productionPlanPublishmentForFactory】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_publishment_for_factory'
        )
      case `【DashboardContentsProductionForm1.productionPlanFactoryForCapacityGraph】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_factory_for_capacity_graph'
        )
      case `【DashboardContentsProductionForm1.productionPlanFactoryCapacityPlan】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_factory_capacity_plan'
        )
      case `【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkSewingFabric】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_2.dashboard_menu_production_item_production_category_link_sewing_fabric'
        )
      case `【DashboardContentsProductionForm1.productionPlanStopGoFileUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_stop_go_file_upload'
        )
      case `【DashboardContentsProductionForm1.productionPlanDLSheet】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_plan_dl_sheet'
        )
      case `【DashboardContentsProductionForm1.productionCapacityGraphOutput】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_production_capacity_graph_output'
        )
      case `【DashboardContentsProductionForm1.representativeManagementFactorySetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_1.dashboard_menu_representative_management_factory_setting'
        )
      case `【DashboardContentsProductionForm2.ProductionItemProductionCategoryLinkFabric】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_2.dashboard_menu_production_item_production_category_link_fabric'
        )
      case `【DashboardContentsProductionForm2.ProductionProcessBasedLeadtime】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_2.dashboard_menu_production_process_based_lead_time'
        )
      case `【DashboardContentsProductionForm2.ProductionOrderConditionRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_2.dashboard_menu_production_order_condition_registration'
        )
      case `【DashboardContentsProductionForm4.productionPlanMdView】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_4.dashboard_menu_production_plan_md_view'
        )
      case `【DashboardContentsProductionForm4.productionPlanPrdFctView】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_4.dashboard_menu_production_plan_prd_fct_view'
        )
      case `【DashboardContentsProductionForm4.productionPlanUnexRawdata】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_4.dashboard_menu_production_plan_unex_rawdata'
        )
      case `【DashboardContentsProductionForm5.ProductionPlanRawdataExport】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_5.dashboard_menu_production_plan_raw_data_export'
        )
      case `【DashboardContentsProductionForm5.DetectionOfOrderProgress】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_production_form_5.dashboard_menu_detection_of_order_progress'
        )
      case `【DashboardContentsOrderForm1.ProductionGlobalColorSizeOrderSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_1.dashboard_menu_production_global_color_size_order_setting'
        )
      case `【DashboardContentsOrderForm1.ProductionReferenceItemMapping】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_1.dashboard_menu_production_reference_item_mapping'
        )
      case `【DashboardContentsOrderForm2.ProductionLocalColorSizeOrderSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_2.dashboard_menu_production_local_color_size_order_setting'
        )
      case `【DashboardContentsOrderForm2.ProductionOrderPlanList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_2.dashboard_menu_production_order_plan_list'
        )
      case `【DashboardContentsOrderForm2.ProductionBDSheet】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_2.dashboard_menu_production_bd_sheet'
        )
      case `【DashboardContentsOrderForm3.ProductionOrderExecutionList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_3.dashboard_menu_production_order_execution_list'
        )
      case `【DashboardContentsOrderForm3.ProductionOrderApprovalList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_3.dashboard_menu_production_order_approval_list'
        )
      case `【DashboardContentsOrderForm3.ProductionOrderApprovalListForMobile】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_3.dashboard_menu_production_order_approval_list_for_mobile'
        )
      case `【DashboardContentsOrderForm4.ProductionCostSequenceNoRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_cost_sequence_no_registration'
        )
      case `【DashboardContentsOrderForm4.ProductionItemAttributeList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_item_attribute_list'
        )
      case `【DashboardContentsOrderForm4.ProductionPackingInstruction】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_packing_instruction'
        )
      case `【DashboardContentsOrderForm4.ProductionWHDistributionRatioRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_wh_distribution_ratio_registration'
        )
      case `【DashboardContentsOrderForm4.ProductionThresholdRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_threshold_registration'
        )
      case `【DashboardContentsOrderForm4.ProductionTransferItemRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_transfer_item_registration'
        )
      case `【DashboardContentsOrderForm4.ProductionDefaultPackingQuantitySetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_default_packing_quantity_setting'
        )
      case `【DashboardContentsOrderForm4.ProductionDoChange】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_do_change'
        )
      case `【DashboardContentsOrderForm4.ProductionDoAllocation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_do_allocation'
        )
      case `【DashboardContentsOrderForm4.ProductionExceptionalItemRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_exceptional_item_registration'
        )
      case `【DashboardContentsOrderForm4.ProductionNAssortRatioRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_order_form_4.dashboard_menu_production_n_assort_ratio_registration'
        )
      case `【DashboardContentsInventoryControlForm.InventoryControlStoreParameterSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_inventory_control_form_left.dashboard_menu_inventory_control_store_parameter_setting'
        )
      case `【DashboardContentsInventoryControlForm.InventoryControlSalesSumParameterSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_inventory_control_form_left.dashboard_menu_inventory_control_sales_sum_parameter_setting'
        )
      case `【DashboardContentsCommonMasterForm.CommonMasterSeasonRateMaster】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_common_master_form.season_rate_master'
        )
      case `【DashboardContentsCommonMasterForm.CommonMasterNumberOfStoreMaster】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_common_master_form.number_of_store_master'
        )
      case `【DashboardContentsMatFormTopLeft.MaterialDiversionRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_top_left.dashboard_menu_material_management_material_diversion_registration'
        )
      case `【DashboardContentsMatFormBottomLeft.OrderExecutionList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_production_order_execution_list'
        )
      case `【DashboardContentsMatFormBottomLeft.OrderApprovalList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_production_order_approval_list'
        )
      case `【DashboardContentsMatFormBottomLeft.OrderApprovalListForMobile】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_production_order_approval_list_for_mobile'
        )
      case `【DashboardContentsMatFormBottomLeft.BoForEarlyMaterialOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_material_management_bo_for_early_material_order'
        )
      case `【DashboardContentsMatFormBottomLeft.BoForReservedMaterialOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_material_management_bo_for_reserved_material_order'
        )
      case `【DashboardContentsMatFormBottomLeft.BdForReservedMaterialOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_left.dashboard_menu_material_management_bd_for_reserved_material_order'
        )
      case `【DashboardContentsMatFormBottomRight.RawdataExportForMaterialRemainsConfirmation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_right.dashboard_menu_material_management_rawdata_export_for_material_remains_confirmation'
        )
      case `【DashboardContentsMatFormBottomRight.MaterialPlanAndOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_bottom_right.dashboard_menu_material_order_plan_by_planning_sum'
        )
      case `【DashboardContentsMatFormTopRight.AutomaticAssignmentExclusionFRMaterialRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_top_right.dashboard_menu_automatic_assignment_exclusion_fr_material_registration'
        )
      case `【DashboardContentsMatFormTopRight.OrderProcessPatternMasterRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_top_right.dashboard_menu_order_process_pattern_master_registration'
        )
      case `【DashboardContentsMatFormTopRight.MasterForMaterialPlanAndOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_mat_form_top_right.dashboard_menu_master_for_material_order_plan_by_planning_sum'
        )
      case `【DashboardContentsAimInventoryCockpitForm.AimControlCockpit】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_inventory_cockpit_form.dashboard_menu_aim_control_cockpit'
        )
      case `【DashboardContentsAimReportForm.AimReferenceForTransfer】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_report_form.dashboard_menu_aim_reference_for_transfer'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfDemandForecast】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_confirmation_of_excel_upload_of_demand_forecast'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimWeeklyStockPlanbyLineupType】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_weekly_stock_plan_by_lineup_type'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStyle】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_order_limit_setting_by_style'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimConfirmationOfExcelUploadOfStoreAlocGthrUpperLowerLimited】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_confirmation_of_excel_upload_of_store_aloc_gthr_upper_lower_limited'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimOrderLimitSettingByStore】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_order_limit_setting_by_store'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatio】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_setting_of_face_ratio'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimDownloadOfFaceRatioFile】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_download_of_face_ratio_file'
        )
      case `【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfDeliveryRatioByDay】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form2.dashboard_menu_aim_confirmation_of_excel_upload_of_delivery_ratio_by_day'
        )
      case `【DashboardContentsAimSPSSettingForm2.AimConfirmationOfExcelUploadOfItemInformation】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form2.dashboard_menu_aim_confirmation_of_excel_upload_of_item_information'
        )
      case `【DashboardContentsAimSPSSettingForm2.AimInformationRegistration】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form2.dashboard_menu_aim_information_registration'
        )
      case `【DashboardContentsAimSPSSettingForm2.AimSettingOfLineTypeByStore】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form2.dashboard_menu_aim_setting_of_line_type_by_store'
        )
      case `【DashboardContentsAimSPSSettingForm2.AimWeeklyStandartStockUploadBySku】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form2.dashboard_menu_aim_weekly_standart_stock_upload_by_sku'
        )
      case `【DashboardContentsAimSPSSettingForm1.AimSettingOfFaceRatioNew】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sps_setting_form1.dashboard_menu_aim_setting_of_face_ratio_new'
        )
      case `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStyle】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form1.dashboard_menu_aim_allocation_parameter_setting_by_style'
        )
      case `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingForEcByStyle】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form1.dashboard_menu_aim_allocation_parameter_setting_for_ec_by_style'
        )
      case `【DashboardContentsAimStoreOrderForm1.AimAllocationParameterSettingByStore】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form1.dashboard_menu_aim_allocation_parameter_setting_by_store'
        )
      case `【DashboardContentsAimStoreOrderForm1.AimReplenishmentDateSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form1.dashboard_menu_aim_replenishment_date_setting'
        )
      case `【DashboardContentsAimStoreOrderForm1.AimProhibitedDeliveryDateSettingByStoreAndGdept】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form1.dashboard_menu_aim_prohibited_delivery_date_setting_by_store_and_gdept'
        )
      case `【DashboardContentsAimStoreOrderForm2.AimReplenishmentTargetSettingBySku】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form2.dashboard_menu_aim_replenishment_target_setting_by_sku'
        )
      case `【DashboardContentsAimStoreOrderForm2.AimSettingOfLayawayStockStatusShift】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form2.dashboard_menu_aim_setting_of_layaway_stock_status_shift'
        )
      case `【DashboardContentsAimStoreOrderForm2.AimDownloadOfLayawayStockStatusFile】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form2.dashboard_menu_aim_download_of_layaway_stock_status_file'
        )
      case `【DashboardContentsAimStoreOrderForm2.AimStoreAllocationPrioritySetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form2.dashboard_menu_aim_store_allocation_priority_setting'
        )
      case `【DashboardContentsAimStoreOrderForm2.AimExcelDownloadOfReplenishmentControl】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_order_form2.dashboard_menu_aim_excel_download_of_replenishment_control'
        )
      case `【DashboardContentsAimSCOrderForm1.AimScOrderHome】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form1.dashboard_menu_aim_sc_order_home'
        )
      case `【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByItem】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form1.dashboard_menu_aim_confirmation_of_excel_uploading_of_sc_order_by_item'
        )
      case `【DashboardContentsAimSCOrderForm1.AimConfirmationOfExcelUploadingOfScOrderByAssortSku】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form1.dashboard_menu_aim_confirmation_of_excel_uploading_of_sc_order_by_assort_sku'
        )
      case `【DashboardContentsAimSCOrderForm2.AimUrgentRequestForShipment】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form2.dashboard_menu_aim_urgent_request_for_shipment'
        )
      case `【DashboardContentsAimSCOrderForm2.AimStoreGroupMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form2.dashboard_menu_aim_store_group_maintenance'
        )
      case `【DashboardContentsAimSCOrderForm2.AimSettingOfTemporaryFaceRatio】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sc_order_form2.dashboard_menu_aim_setting_of_temporary_face_ratio'
        )
      case `【DashboardContentsAimTransferConsolidationForm.AimSearchForTransferOfAllItemsAndReturnToVender】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_transfer_consolidation_form.dashboard_menu_aim_search_for_transfer_of_all_items_and_return_to_vender'
        )
      case `【DashboardContentsAimTransferConsolidationForm.AimAreaManagerStoreToStoreDeliveryOrder】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_transfer_consolidation_form.dashboard_menu_aim_area_manager_store_to_store_delivery_order'
        )
      case `【DashboardContentsAimTransferConsolidationForm.AimSettingOfTransferToConcentrateStock】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_transfer_consolidation_form.dashboard_menu_aim_setting_of_transfer_to_concentrate_stock'
        )
      case `【DashboardContentsAimStoreSettingForm.AimLogisticsTerritoryMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_setting_form.dashboard_menu_aim_logistics_territory_maintenance'
        )
      case `【DashboardContentsAimStoreSettingForm.AimSettingOfPriorityAllocationByStore】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_setting_form.dashboard_menu_aim_setting_of_priority_allocation_by_store'
        )
      case `【DashboardContentsAimStoreSettingForm.AimLogisticsMasterMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_setting_form.dashboard_menu_aim_logistics_master_maintenance'
        )
      case `【DashboardContentsAimItemSettingForm.AimWarehouseByItemCollectiveSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_item_setting_form.dashboard_menu_aim_warehouse_by_item_collective_setting'
        )
      case `【DashboardContentsAimItemSettingForm.AimSettingOfWarehouseByItem】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_item_setting_form.dashboard_menu_aim_setting_of_warehouse_by_item'
        )
      case `【DashboardContentsAimTransferForm.AimTransferSearchWindow】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_transfer_form.dashboard_menu_aim_transfer_search_window'
        )
      case `【DashboardContentsAimTransferForm.AimTransferInstructionWarehouseExcelUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_transfer_form.dashboard_menu_aim_transfer_instruction_warehouse_excel_upload'
        )
      case `【DashboardContentsAimMinimumDeliveryQuantityForm.AimSettingOfMinimumQtyByGdeptClass】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_minimum_delivery_quantity_form.dashboard_menu_aim_setting_of_minimum_qty_by_gdept_class'
        )
      case `【DashboardContentsAimWhWhMasterForm.AimWh2WhOrderRegionMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_master_form.dashboard_menu_aim_wh_2_wh_order_region_maintenance'
        )
      case `【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLowerLimitOfShippable】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_master_form.dashboard_menu_aim_wh_2_wh_logistics_master_maintenance_lower_limit_of_shippable'
        )
      case `【DashboardContentsAimWhWhMasterForm.AimWh2WhLogisticsMasterMaintenanceLeadTime】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_master_form.dashboard_menu_aim_wh_2_wh_logistics_master_maintenance_lead_time'
        )
      case `【DashboardContentsAimWhWhMasterForm.AimWh2WhSettingOfCartonVolume】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_master_form.dashboard_menu_aim_wh_2_wh_setting_of_carton_volume'
        )
      case `【DashboardContentsAimWhWhOrderForm.AimWh2WhReplenishmentApprovalByGdept】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_order_form.dashboard_menu_aim_wh_2_wh_replenishment_approval_by_gdept'
        )
      case `【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingItem】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_order_form.dashboard_menu_aim_wh_2_wh_allocation_item_setting_item'
        )
      case `【DashboardContentsAimWhWhOrderForm.AimWh2WhAllocationItemSettingCopySetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_wh_wh_order_form.dashboard_menu_aim_wh_2_wh_allocation_item_setting_copy_setting'
        )
      case `【DashboardContentsAimSumMaintenanceForm.AimSumCodeSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sum_maintenance_form.dashboard_menu_aim_sum_code_setting'
        )
      case `【DashboardContentsAimSumMaintenanceForm.AimRepSkuSetting】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sum_maintenance_form.dashboard_menu_aim_rep_sku_setting'
        )
      case `【DashboardContentsAimSumMaintenanceForm.AimAllocationPrioritySettingBySku】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sum_maintenance_form.dashboard_menu_aim_allocation_priority_setting_by_sku'
        )
      case `【DashboardContentsAimSumMaintenanceForm.AimUserAttributeMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sum_maintenance_form.dashboard_menu_aim_user_attribute_maintenance'
        )
      case `【DashboardContentsAimAssortmaintenanceForm.AimAssortmentMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_assort_maintenance_form.dashboard_menu_aim_assortment_maintenance'
        )
      case `【DashboardContentsAimPriceChangeForm.AimPriceChangeSearch】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_price_change_form.dashboard_menu_aim_price_change_search'
        )
      case `【DashboardContentsAimPriceChangeForm.AimPriceChangeExcelUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_price_change_form.dashboard_menu_aim_price_change_excel_upload'
        )
      case `【DashboardContentsAimPriceChangeForm.AimPricelineMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_price_change_form.dashboard_menu_aim_priceline_maintenance'
        )
      case `【DashboardContentsAimPromotionForm.AimEventList】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_promotion_form.dashboard_menu_aim_event_list'
        )
      case `【DashboardContentsAimPromotionForm.AimPromotionExcelUpload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_promotion_form.dashboard_menu_aim_promotion_excel_upload'
        )
      case `【DashboardContentsAimPromotionForm.AimPromotionExcelUploadItemAndPrice】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_promotion_form.dashboard_menu_aim_promotion_excel_upload_item_and_price'
        )
      case `【DashboardContentsAimInventoryMaintenanceForm.AimSearchForDeliveryAndShipmentHistory】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_inventory_maintenance_form.dashboard_menu_aim_search_for_delivery_and_shipment_history'
        )
      case `【DashboardContentsAimInventoryMaintenanceForm.AimConfirmationOfExcelUploadingOfShipment】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_inventory_maintenance_form.dashboard_menu_aim_confirmation_of_excel_uploading_of_shipment'
        )
      case `【DashboardContentsAimInventoryMaintenanceForm.AimInventoryAdjustmentStockStatusShift】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_inventory_maintenance_form.dashboard_menu_aim_inventory_adjustment_stock_status_shift'
        )
      case `【DashboardContentsAimInventoryMaintenanceForm.AimBookTransfer】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_inventory_maintenance_form.dashboard_menu_aim_book_transfer'
        )
      case `【DashboardContentsAimStockTakingForm.AimStockTakeRequestMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_stock_taking_form.dashboard_menu_aim_stock_take_request_maintenance'
        )
      case `【DashboardContentsAimStockTakingForm.AimConfirmationOfExcelUploadingOfStocktakingAdjustment】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_stock_taking_form.dashboard_menu_aim_confirmation_of_excel_uploading_of_stocktaking_adjustment'
        )
      case `【DashboardContentsAimStockTakingForm.AimExcelOutputOfStocktakingAdjustment】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_stock_taking_form.dashboard_menu_aim_excel_output_of_stocktaking_adjustment'
        )
      case `【DashboardContentsAimMasterForm.AimMasterDownload】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_master_form.dashboard_menu_aim_master_download'
        )
      case `【DashboardContentsAimStoreMasterForm.AimStoreMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_master_form.dashboard_menu_aim_store_maintenance'
        )
      case `【DashboardContentsAimStoreMasterForm.AimAreaMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_master_form.dashboard_menu_aim_area_maintenance'
        )
      case `【DashboardContentsAimStoreMasterForm.AimBlockMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_store_master_form.dashboard_menu_aim_block_maintenance'
        )
      case `【DashboardContentsAimLogisticsMasterForm.AimWarehouseMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_logistics_master_form.dashboard_menu_aim_warehouse_maintenance'
        )
      case `【DashboardContentsAimLogisticsMasterForm.AimOrderRegionMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_logistics_master_form.dashboard_menu_aim_order_region_maintenance'
        )
      case `【DashboardContentsAimLogisticsMasterForm.AimLogisticsCompanyMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_logistics_master_form.dashboard_menu_aim_logistics_company_maintenance'
        )
      case `【DashboardContentsAimLogisticsMasterForm.AimReferenceNumberMasterMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_logistics_master_form.dashboard_menu_aim_reference_number_master_maintenance'
        )
      case `【DashboardContentsAimPOSMasterForm.AimTenderType】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_master_form.dashboard_menu_aim_tender_type'
        )
      case `【DashboardContentsAimPOSMasterForm.AimMaintenanceOfCreditCompanyInfo】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_master_form.dashboard_menu_aim_maintenance_of_credit_company_info'
        )
      case `【DashboardContentsAimPOSMasterForm.AimCodeMaintenanceOfNonItemSales】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_master_form.dashboard_menu_aim_code_maintenance_of_non_item_sales'
        )
      case `【DashboardContentsAimPOSDataForm.AimPosDataSearch】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_pos_data_search'
        )
      case `【DashboardContentsAimPOSDataForm.AimStoreSummaryDataDetail】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_store_summary_data_detail'
        )
      case `【DashboardContentsAimPOSDataForm.AimReferenceOfBalanceBetweenSalesAndPos】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_reference_of_balance_between_sales_and_pos'
        )
      case `【DashboardContentsAimPOSDataForm.AimReferenceOfSalesDataCollection】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_reference_of_sales_data_collection'
        )
      case `【DashboardContentsAimPOSDataForm.AimSearchForDailyConditionOfStores】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_search_for_daily_condition_of_stores'
        )
      case `【DashboardContentsAimPOSDataForm.AimSearchForChangeHistoryOfPosData】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_pos_data_form.dashboard_menu_aim_search_for_change_history_of_pos_data'
        )
      case `【DashboardContentsAimSystemControlForm.AimPosDataFileImport】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_system_control_form.dashboard_menu_aim_pos_data_file_import'
        )
      case `【DashboardContentsAimSystemControlForm.AimEndOfMonthProcessing】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_system_control_form.dashboard_menu_aim_end_of_month_processing'
        )
      case `【DashboardContentsAimSystemControlForm.AimDelayedOnlineBatchManagement】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_system_control_form.dashboard_menu_aim_delayed_online_batch_management'
        )
      case `【DashboardContentsAimSystemControlForm.AimDataDeliveryToStoresOnSystemErrors】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_system_control_form.dashboard_menu_aim_data_delivery_to_stores_on_system_errors'
        )
      case `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimGeocodeHierarchyMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sales_tax_vat_maintenance_form.dashboard_menu_aim_geocode_hierarchy_maintenance'
        )
      case `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxHierarchy】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sales_tax_vat_maintenance_form.dashboard_menu_aim_tax_hierarchy'
        )
      case `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimTaxRateView】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sales_tax_vat_maintenance_form.dashboard_menu_aim_tax_rate_view'
        )
      case `【DashboardContentsAimSalesTaxVATMaintenanceForm.AimVATItemMaintenance】を押したとき` :
        return this.eventHub.whenItemPressed(
          'cmnfnc_base.plncmm10000sc00_00.dashboard.contents_form.dashboard_contents_panel.dashboard_contents_grid.dashboard_contents_aim_sales_tax_vat_maintenance_form.dashboard_menu_aim_vat_item_maintenance'
        )
      default:
        return Observable.never()
    }
  }

}


// WEBPACK FOOTER //
// ./src/features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.component.page.ts